import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import PopConfirm from '@omilia/popconfirm';
import { Row, Col } from 'react-flexbox-grid';

import _get from 'lodash/get';
import _trim from 'lodash/trim';
import _times from 'lodash/times';
import _isNumber from 'lodash/isNumber';

import * as TYPES from 'types';

import Toggler from 'components/Toggler';
import ReorderMenu from 'components/ReorderMenu';
import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';

import { FormGroupTextarea, FormGroupField } from 'components/Form';
import FormGroupAutoCompleteField from 'components/AutoCompleteMenuWrapper';

import { setOrderIndex } from 'scenes/Rules/utils';

import './style.scss';

/* eslint-disable react/destructuring-assignment */
class GeneralTab extends Component {
  static propTypes = {
    change: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onDeleteRule: PropTypes.func.isRequired,
    onGetAllRuleGroups: PropTypes.func.isRequired,
    allRuleGroups: PropTypes.arrayOf(TYPES.ruleGroupType),
    formValues: PropTypes.shape({
      group: PropTypes.shape({
        id: PropTypes.string,
        order: PropTypes.number,
      }),
      order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    isArchived: PropTypes.bool,
    rootOrderList: PropTypes.arrayOf(
      PropTypes.shape({
        index: PropTypes.number,
        order: PropTypes.string,
      }),
    ),
  };

  static defaultProps = {
    formValues: {
      order: 0,
      group: {
        order: 0,
        rules: [],
      },
    },
  };

  state = {
    isReorderMenuOpen: false,
  };

  handleGetRuleGroups = (searchTerm = '') => {
    this.props.onGetAllRuleGroups({
      size: 100,
      visible: true,
      name__icontains: searchTerm,
    });
  };

  handleGroupChange = ({ order, rules = [] }) => {
    if (_isNumber(order)) {
      this.props.change('order', `${order + 1}.${rules.length + 1}`);
    } else if (this.props.formValues.group) {
      this.props.change('order', this.props.rootOrderList.length + 1);
    }
  };

  handleReorder = order => {
    this.props.change('order', order);
  };

  handleOpenReorderMenu = () => {
    this.setState({
      isReorderMenuOpen: true,
    });
  };

  handleCloseReorderMenu = () => {
    this.setState({
      isReorderMenuOpen: false,
    });
  };

  render() {
    const { isReorderMenuOpen } = this.state;
    const {
      isArchived,
      isLoading,
      allRuleGroups,
      formValues,
      rootOrderList,
      onDeleteRule,
    } = this.props;

    if (!formValues) {
      return null;
    }

    const { order, group } = formValues;
    let orderList = rootOrderList;
    if (group) {
      orderList = _times(_get(group, 'rules.length', 0), i => ({
        order: `${group.order + 1}.${i + 1}`,
        index: i + 1,
      }));
    }

    return (
      <div styleName="root">
        <InspectHeader>
          {!isArchived && (
            <PopConfirm
              confirmLabel="Yes"
              declineLabel="Cancel"
              placement="left"
              title="Are you sure you want to delete this context rule?"
              onConfirm={onDeleteRule}
            >
              <InspectButton isHeader data-test="delete-rule">
                + Delete Context Rule
              </InspectButton>
            </PopConfirm>
          )}
        </InspectHeader>

        <div styleName="inner">
          <Row styleName="row">
            <Col styleName="order" xs={1}>
              {/* FIXME: */}
              {isReorderMenuOpen && (
                <ReorderMenu
                  isGrouped
                  isOpen
                  index={setOrderIndex(orderList, order.toString())}
                  isDisabled={isArchived}
                  mode="input"
                  model={{ order }}
                  orderList={orderList}
                  reorderItem={this.handleReorder}
                  onClose={this.handleCloseReorderMenu}
                />
              )}

              <Field
                autoComplete="off"
                component={FormGroupField}
                data-test="rule-order"
                disabled={isArchived}
                label="ORDER"
                name="order"
                placeholder="Order"
                type="text"
                onClick={this.handleOpenReorderMenu}
              />
            </Col>

            <Col xs>
              <Field
                autoFocus
                component={FormGroupField}
                data-test="rule-name"
                disabled={isArchived}
                label="CONTEXT RULE NAME"
                name="name"
                normalize={_trim}
                placeholder="Context rule name"
                type="text"
              />
            </Col>

            <Col styleName="group" xs={3}>
              <Field
                withDropCross
                component={FormGroupAutoCompleteField}
                data-test="select-group"
                isDisabled={isArchived}
                isLoading={isLoading}
                items={allRuleGroups}
                label="GROUP"
                name="group"
                placeholder="Select a group"
                onChange={this.handleGroupChange}
                onChangeValue={this.handleGetRuleGroups}
                onOpen={this.handleGetRuleGroups}
              />
            </Col>

            <Col xs={2}>
              <Field
                component={Toggler}
                data-test="toggle-active"
                isDisabled={isArchived}
                label="Active"
                name="enabled"
                styleName="toggler-field"
              />
            </Col>
          </Row>

          <Row styleName="row">
            <Col xs>
              <Field
                cols="30"
                component={FormGroupTextarea}
                data-test="rule-description"
                disabled={isArchived}
                label="DESCRIPTION"
                name="description"
                placeholder="Context rule description"
                rows="6"
                type="textarea"
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default GeneralTab;
